export function getLocalTimezoneOffset(): number {
	const offset = new Date().getTimezoneOffset();

	return -offset;
}
